import type { OrderDirectionEnum, SortByEnum } from '@/shared/api/intranet'
import type { RoutesWithPage } from '@/shared/lib'

export const usePagination = <TSort extends string = SortByEnum>(
  routeName: RoutesWithPage,
  sortParams?: { order?: Nullable<OrderDirectionEnum>; sort?: Nullable<TSort> },
) => {
  const order = ref<Nullable<OrderDirectionEnum>>(sortParams?.order || null)
  const sort = ref<Nullable<TSort>>(sortParams?.sort || null)
  const page = ref(1)
  const query = ref('')
  const showDeleted = ref(false)

  const route = useRoute(routeName)
  const router = useRouter()
  const routePage = computed(() => Number((route.params as { page?: string }).page))
  if (!Number.isNaN(routePage.value) && routePage.value !== 0) {
    page.value = routePage.value
  }
  const updatePage = (
    newVal: number,
    additionalParams: Record<string, string | number | undefined> = {},
    additionalQuery: Record<string, string | number | undefined> = {},
  ) => {
    const params: Record<string, string | number> = { ...route.params, ...additionalParams, page: newVal }
    const queryParams = { ...route.query, ...additionalQuery }
    page.value = newVal
    return router.push({ name: routeName, params, query: queryParams })
  }
  const resetPage = () => {
    page.value = 1
  }

  const resetSort = () => {
    order.value = sortParams?.order || null
    sort.value = sortParams?.sort || null
  }
  const setSort = (newSort: Nullable<TSort>) => {
    sort.value = newSort
  }
  const setOrder = (newOrder: Nullable<OrderDirectionEnum>) => {
    order.value = newOrder
  }
  const setShowDeleted = (newVal: boolean) => {
    showDeleted.value = newVal
  }
  const resetPagination = () => {
    resetPage()
    resetSort()
    query.value = ''
  }

  return {
    order,
    sort,
    page,
    query,
    showDeleted,
    resetPagination,
    resetSort,
    resetPage,
    setSort,
    setOrder,
    setShowDeleted,
    updatePage,
  }
}
